import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IDetail {
    id?: string
    title?: string
    startTime?: string
    location?: string
    presenter?: string
    content?: string
    meetingMode?: string
    meetingType?: string
    createUser?: string
    checkinCode?: string
    qrcodePath?: string
    status?: string | number
    createTime?: string
    onlineMeetingDetailsList?: any[]
    driverInformationList?: any[]
    meetingCheckinList?: any[]
    meetingsImgList?: any[]
    [key: string]: any
}
//新增
export interface IInsert {
    id?: string
    title?: string
    startTime?: string
    location?: string
    presenter?: string
    content?: string
    meetingType?: string
    meetingMode?: string
    createUser?: string
    checkinCode?: string
    qrcodePath?: string
    onlineMeetingDetailsList?: any[]
    meetingsUserList?: any[]
}

//编辑
export interface IUpdate extends IInsert {
    id?: string
    status?: string
}
//搜索条件
export interface ISearchFields {
    content?: string
    startTime?: string
    endTime?: string
    meetingType?: string
    [key: string]: any
}

export interface ISearch extends ISearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

class service {
    async page(searchVo: ISearch, config: object = {}) {
        const apiUrl = '/threeInspection/announcement/list'
        return await httpRequest.post<IPage<IDetail>>(apiUrl, searchVo, config)
    }
    async insert(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/announcement/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/announcement/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/announcement/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async one(id: string) {
        const apiUrl = '/threeInspection/announcement/one/' + id
        return await httpRequest.get<any>(apiUrl)
    }
    async publish(updateVo: IUpdate) {
        const apiUrl = '/threeInspection/announcement/publish'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async driverList(searchVo: ISearch, config: object = {}) {
        const apiUrl = '/threeInspection/base/driver/list'
        return await httpRequest.post<IPage<IDetail>>(apiUrl, searchVo, config)
    }
    async exportPDF(id: string) {
        const apiUrl = '/threeInspection/announcement/export/' + id
        return await httpRequest.getFile(apiUrl)
    }
}

export const Service = new service()
